import React from "react";
import "../../styles/common/sortable-header.css";

const LongUpArrow = ({ color = "#6c757d", size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M11.0001 22.0003L13 22.0004L13 8.41421L18.4142 8.41421L12 2L5.58575 8.41421L11 8.41421L11.0001 22.0003Z" />
  </svg>

  // <svg
  //   width={size}
  //   height={size}
  //   viewBox="0 0 24 24"
  //   fill="none"
  //   stroke={color}
  //   strokeWidth="2.5"
  //   strokeLinecap="round"
  //   strokeLinejoin="round"
  // >
  //   <path d="M12 20V4M6 10l6-6 6 6" />
  // </svg>
);

const LongDownArrow = ({ color = "#6c757d", size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M12.9999 1.99974L11 1.9996L11 15.5858H5.58582L12 22L18.4142 15.5858L13 15.5858L12.9999 1.99974Z" />
  </svg>

  // <svg
  //   width={size}
  //   height={size}
  //   viewBox="0 0 24 24"
  //   fill="none"
  //   stroke={color}
  //   strokeWidth="2.5"
  //   strokeLinecap="round"
  //   strokeLinejoin="round"
  // >
  //   <path d="M12 4v16M18 14l-6 6-6-6" />
  // </svg>
);

/**
 * Reusable sortable header component
 * @param {string} text - Header text
 * @param {string} field - Field name for sorting
 * @param {Function} onSort - Sort handler function
 * @param {string} sortDirection - Current sort direction ('asc', 'desc', or null)
 * @param {boolean} isSorted - Whether this field is currently sorted
 * @param {string} className - Additional CSS classes
 */

const SortableHeader = ({
  text,
  field,
  onSort,
  sortDirection,
  isSorted,
  className = "",
}) => {
  const handleClick = (event) => {
    onSort(field, event);
  };

  const handleArrowClick = (event, direction) => {
    event.stopPropagation();

    if (isSorted && sortDirection === direction) {
      const syntheticEvent = {
        ...event,
        detail: 2,
        type: "dblclick",
      };
      onSort(field, syntheticEvent);
      return;
    }

    setSortingDirection(direction);
  };

  const setSortingDirection = (direction) => {
    if (direction === "asc") {
      onSort(field, { detail: 1, direction: "asc" });
    } else {
      onSort(field, { detail: 1, direction: "desc" });
    }
  };

  return (
    <div
      className={`sortable-header ${className}`}
      onClick={handleClick}
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        userSelect: "none",
      }}
    >
      <span>{text}</span>
      <div
        className="sort-icons"
        style={{ display: "flex", flexDirection: "row", gap: "3px" }}
      >
        <div
          onClick={(e) => handleArrowClick(e, "asc")}
          style={{ cursor: "pointer" }}
        >
          <LongUpArrow
            size={16}
            color={isSorted && sortDirection === "asc" ? "#007bff" : "#6c757d"}
            style={{
              opacity: isSorted && sortDirection === "asc" ? 1 : 0.8,
              transition: "all 0.2s ease",
            }}
          />
        </div>
        <div
          onClick={(e) => handleArrowClick(e, "desc")}
          style={{ cursor: "pointer" }}
        >
          <LongDownArrow
            size={16}
            color={isSorted && sortDirection === "desc" ? "#007bff" : "#6c757d"}
            style={{
              opacity: isSorted && sortDirection === "desc" ? 1 : 0.8,
              transition: "all 0.2s ease",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SortableHeader;
